import React from 'react';
import { motion } from 'framer-motion';
import { FaLeaf, FaStar, FaHeart } from 'react-icons/fa';
import {cardFloat} from "../animations/animations";


const BrandMessage = () => {
    return (
        <motion.div
            variants={cardFloat}
            className="bg-gradient-to-br from-champagne/5 via-pearl to-sage/5 rounded-3xl p-8 md:p-12"
        >
            <div className="max-w-3xl mx-auto text-center">
                {/* Decorative Icons */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2 }}
                    className="flex justify-center gap-6 mb-8"
                >
                    <motion.div
                        animate={{ rotate: [0, 10, 0] }}
                        transition={{ duration: 3, repeat: Infinity }}
                        className="w-12 h-12 rounded-full bg-white flex items-center justify-center"
                    >
                        <FaLeaf className="w-5 h-5 text-sage" />
                    </motion.div>
                    <motion.div
                        animate={{ scale: [1, 1.1, 1] }}
                        transition={{ duration: 2, repeat: Infinity }}
                        className="w-12 h-12 rounded-full bg-white flex items-center justify-center"
                    >
                        <FaStar className="w-5 h-5 text-champagne" />
                    </motion.div>
                    <motion.div
                        animate={{ rotate: [0, -10, 0] }}
                        transition={{ duration: 3, repeat: Infinity }}
                        className="w-12 h-12 rounded-full bg-white flex items-center justify-center"
                    >
                        <FaHeart className="w-5 h-5 text-champagne" />
                    </motion.div>
                </motion.div>

                {/* Brand Message */}
                <motion.h2
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.3 }}
                    className="font-heading text-3xl md:text-4xl font-light text-charcoal mb-6"
                >
                    KROMAIC is honored to be part of your beauty ritual
                </motion.h2>

                <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.4 }}
                    className="text-charcoal/60 text-lg leading-relaxed mb-8"
                >
                    Each product is crafted with intention, designed to transform not just
                    your skin, but your daily ritual. We believe beauty is a practice—a
                    moment of care that honors both yourself and the world around you.
                </motion.p>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.5 }}
                    className="flex flex-wrap justify-center gap-4"
                >
                    <div className="text-center">
                        <div className="text-2xl font-light text-charcoal mb-1">24/7</div>
                        <div className="text-sm text-charcoal/50">Beauty Support</div>
                    </div>
                    <div className="text-center">
                        <div className="text-2xl font-light text-charcoal mb-1">30</div>
                        <div className="text-sm text-charcoal/50">Day Returns</div>
                    </div>
                    <div className="text-center">
                        <div className="text-2xl font-light text-charcoal mb-1">100%</div>
                        <div className="text-sm text-charcoal/50">Cruelty Free</div>
                    </div>
                    <div className="text-center">
                        <div className="text-2xl font-light text-charcoal mb-1">Carbon</div>
                        <div className="text-sm text-charcoal/50">Neutral</div>
                    </div>
                </motion.div>
            </div>
        </motion.div>
    );
};

export default BrandMessage;